import { HelperManager } from '../utils/Helper';
import { $window } from '../global';
import $ from 'jquery'; // required for $.datepicker._updateDatepicker to be able reachable
class DatepickerManager {
    lastSelectedInput;
    repositionTimeout;
    windowWidth;
    constructor() {
        const $selector = $('.js-DatePicker');
        if ($selector.length === 0)
            return;
        (async () => {
            await import('../libraries/jquery-ui-datepicker');
            this.setColors();
            const language = HelperManager.getCultureCode();
            let regionOptions;
            if (language) {
                regionOptions = $.datepicker.regional[language.substr(0, 2)];
                $.datepicker.setDefaults(regionOptions);
            }
            $selector
                .attr('placeholder', regionOptions.placeholder || 'dd-mm-yyyy')
                .datepicker({
                changeYear: true,
                yearRange: '1850:+20',
                dateFormat: 'dd-mm-yy'
            })
                .on('change', function () {
                if ($(this).valid)
                    $(this).valid();
            });
            this.windowWidth = $window.width();
            $window.resize(() => {
                const windowWidth = $window.width();
                if (this.windowWidth === windowWidth)
                    return;
                this.windowWidth = windowWidth;
                this.queueReposition();
            });
        })();
    }
    queueReposition() {
        if (!this.lastSelectedInput && !$.datepicker._datepickerShowing)
            return;
        if (!this.lastSelectedInput) {
            this.lastSelectedInput = $.datepicker._curInst.input;
            this.lastSelectedInput.datepicker('hide');
        }
        clearTimeout(this.repositionTimeout);
        this.repositionTimeout = window.setTimeout(() => this.reposition(), 250);
    }
    reposition() {
        if (!this.lastSelectedInput)
            return;
        this.lastSelectedInput.datepicker('show');
        this.lastSelectedInput = null;
    }
    setColors() {
        const oldFn = $.datepicker._updateDatepicker;
        $.datepicker._updateDatepicker = function (inst) {
            oldFn.call(this, inst);
            const $content = $(this).datepicker('widget');
            $content.find('a').addClass('Btn Btn-Default Btn-White');
        };
    }
}
const datepickerManager = new DatepickerManager();
export { DatepickerManager, datepickerManager };
